<script setup lang="ts">
import type { PaginationResource } from "@carnet/api/backoffice";

defineProps<{
  pagination: PaginationResource | undefined;
}>();

const page = defineModel<number>("page", { required: true });

const { t } = useI18n();
</script>

<template>
  <nav v-if="pagination && pagination.pages > 1" :aria-label="t('ui.pagination.label')" class="flex justify-center">
    <UPagination
      v-model:page="page"
      :total="pagination.total"
      :items-per-page="pagination.size"
      variant="ghost"
      active-color="secondary"
      :show-edges="true"
      :sibling-count="1"
      :show-controls="false"
      :ui="{ item: 'data-[selected]:pointer-events-none hover:bg-lagoon-300/20' }"
    >
      <template #ellipsis="{ ui }">
        <UButton as="div" color="neutral" variant="ghost" label="…" :ui="{ label: ui.label() }" square />
      </template>
    </UPagination>
  </nav>
</template>
